import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import KiosksRoute from "./Kiosk/KiosksRoute";
import App from "./App";
import NotFound from "./App/Components/NotFound";
import ShowCaseRoute from "./ShowCase/ShowCaseRoute";
import Login from "./App/Auth/Login";
import { getCookie } from "typescript-cookie";

const checkUserAuth = () => {
  return document.cookie.includes("user=");
};

const MainApp = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentPath = location.pathname;

    if (!searchParams.toString()) {
      const cookieURL = getCookie("URLAiVisualizer");

      if (cookieURL) {
        const decodedURL = decodeURIComponent(cookieURL);
        navigate(`${currentPath}?${decodedURL}`, { replace: true });
      } else {
        navigate("/login");
      }
    }
  }, [location.search, location.pathname, navigate]);

  const redirectToLoginWithQueryParams = () => {
    const searchParams = location.search;
    return `/login${searchParams}`;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          checkUserAuth() ? (
            <App />
          ) : (
            <Navigate to={redirectToLoginWithQueryParams()} />
          )
        }
      />
      <Route
        path="/ai-visualizer"
        element={
          checkUserAuth() ? (
            <App />
          ) : (
            <Navigate to={redirectToLoginWithQueryParams()} />
          )
        }
      />
      <Route path="/kiosksapp/*" element={<KiosksRoute />} />
      <Route
        path="/show-case/*"
        element={
          checkUserAuth() ? (
            <ShowCaseRoute />
          ) : (
            <Navigate to={redirectToLoginWithQueryParams()} />
          )
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default MainApp;
